import { render, staticRenderFns } from "./dptinfo.vue?vue&type=template&id=40d208bf&scoped=true"
import script from "./dptinfo.vue?vue&type=script&lang=js"
export * from "./dptinfo.vue?vue&type=script&lang=js"
import style0 from "./dptinfo.vue?vue&type=style&index=0&id=40d208bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d208bf",
  null
  
)

export default component.exports